import '@tencent/tpm-meeting/lib/ComHero/style';
import React, { useContext } from 'react';
import styles from './index.module.scss';
import classnames from 'classnames';
import ProductDetailContext from '../../context/ProductDetailContext';
import { PackageNodeTypeBaseline, PackageNodeTypePatch } from '@/tpss/types';

const ProductPackageTypeSwitcher: React.FC = () => {
  // const [packages, setPackages] = useState<ProductPackage[]>([]);

  const { currentSoftwareType } = useContext(ProductDetailContext);
  const { setCurrentSoftwareType } = useContext(ProductDetailContext);
  const { setTargetPackageData } = useContext(ProductDetailContext);
  const { chooseBaselinePackageNode } = useContext(ProductDetailContext);
  const { selectedBaselinePackageData } = useContext(ProductDetailContext);
  const currentPatchList = useContext(ProductDetailContext).currentPatchList;

  function switchType(type: string) {
    setTargetPackageData(selectedBaselinePackageData);
    setCurrentSoftwareType(type);
  }

  return (
    <div
      className={classnames([styles.packageTypeSwitcherContainer, styles.isActive])}
    >
      <div
        className={classnames([
          styles.packageTypeSwitcherItem,
          currentSoftwareType === PackageNodeTypeBaseline ? styles.isActive : '',
          currentSoftwareType === PackageNodeTypeBaseline
            ? styles.packageTypeSwitcherItemActive
            : styles.packageTypeSwitcherItemDeactive
        ])}
        onClick={() => {
          switchType(PackageNodeTypeBaseline);
        }}
      >
        安装包
      </div>
      <div
        className={classnames([
          styles.packageTypeSwitcherItem,
          currentSoftwareType === PackageNodeTypePatch ? styles.isActive : '',
          currentSoftwareType === PackageNodeTypePatch
            ? styles.packageTypeSwitcherItemActive
            : styles.packageTypeSwitcherItemDeactive
        ])}
        style={{
          display: currentPatchList.length > 0 ? '' : 'none'
        }}
        onClick={() => {
          switchType(PackageNodeTypePatch);
          chooseBaselinePackageNode(selectedBaselinePackageData);
        }}
      >
        补丁包
      </div>
    </div>
  );
};

export default ProductPackageTypeSwitcher;
